<template>
    <div class="back-to-top" @click="scrollToTop" :class="{ visible: isVisible }">
        <!-- <svg class="progress-ring" width="50" height="50">
            <circle class="progress-ring__circle" stroke-width="4" fill="transparent" :stroke-dasharray="circumference"
                :stroke-dashoffset="offset" r="20" cx="25" cy="25">
            </circle>
        </svg> -->
        <van-icon name="back-top" size="24" />
    </div>
</template>

<script>
export default {
    name: 'BackToTop',
    props: {
        targetId: {
            type: String
        },
        // 滚动距离阈值，默认为200px
        threshold: {
            type: Number,
            default: 200
        }
    },
    data () {
        return {
            isVisible: false,
            scrollPosition: 0,
            scrollContainer: null
        }
    },
    methods: {
        // 设置滚动容器（通过指令调用）
        setScrollContainer (el) {
            this.scrollContainer = el;
            this.initScrollListener();
        },
        // 初始化滚动监听器
        initScrollListener () {
            if (!this.scrollContainer) {
                this.showNotification('错误：滚动容器未定义', 'error');
                return;
            }
            this.scrollContainer.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
        },
        scrollToTop () {
            if (!this.scrollContainer) {
                this.showNotification('错误：无法滚动，容器未定义', 'error');
                return;
            }
            console.log('滚动到顶部');

            this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        },
        handleScroll () {
            if (!this.scrollContainer) return;
            //const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.scrollPosition = this.scrollContainer.scrollTop || this.scrollContainer.scrollY;
            
            this.isVisible = this.scrollPosition > this.threshold;
        },
        showNotification (text, type) {
            // this.$root.showNotification(text, type);
            console.error(type,text);
        },
    },
    mounted () {
        //console.log(this.scrollContainer);
        // this.target.addEventListener('scroll', this.handleScroll);
        // this.handleScroll();
        // 确保在 DOM 更新后执行
        this.$nextTick(() => {
            if (this.targetId) {
                const container = document.getElementById(this.targetId);
                if (container) {
                    this.scrollContainer = container;
                    this.initScrollListener();
                } else {
                    this.showNotification(`错误：未找到ID为${this.targetId}的元素`, 'error');
                }
            }
            else {
                this.scrollContainer = window;
                this.initScrollListener();
            }
        });
    },
    beforeDestroy () {
        // 组件销毁前移除事件监听
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', this.handleScroll);
        }
        //this.target.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style scoped>
.back-to-top {
    position: fixed;
    bottom: 60px;
    right: 15px;
    width: 38px;
    height: 38px;
    /* background: linear-gradient(135deg, #3498db, #8e44ad); */
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
    opacity: 0;
    transform: translateY(100px);
    transition: all 0.4s ease;
    z-index: 999;
}

.back-to-top.visible {
    opacity: 1;
    transform: translateY(0);
}

.back-to-top:hover {
    /* background: linear-gradient(135deg, #2980b9, #9b59b6); */
    transform: scale(1.1) translateY(0);
}

.progress-ring {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 50px;
    height: 50px;
}

.progress-ring__circle {
    transition: stroke-dashoffset 0.35s;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    stroke: rgba(255, 255, 255, 0.3);
}
</style>
